import { IconAlert } from "@odmonorepo/core-components";
import { useIntl, FormattedMessage } from "react-intl";

export const ErrorAlert = ({ status }: { status?: number }) => {
  if (!status) return null;
  const intl = useIntl();
  return (
    <IconAlert variant="danger">
      <FormattedMessage id={`OTP.error.${status}`} defaultMessage={
        intl.formatMessage({ id: `OTP.error.default` })
      }/>
    </IconAlert>
  );
};

export default ErrorAlert;
